import React, { useState } from "react";
import { Form, Input, Button, Icon } from "antd";
import { Redirect } from "react-router-dom";

import Header from "../../User/Header";

import { useAxios } from "../../shared/hooks/useAxios";
import { useNotification } from "../../shared/hooks/useNotification";

const FromAlterarSenha = ({ form }) => {
    const [confirmDirty, setConfirmDirty] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== form.getFieldValue("novaPassword")) {
            callback("Senhas não coincidentes");
        } else {
            callback();
        }
    };

    const validateToNextPassword = (rule, value, callback) => {
        if (value && confirmDirty) {
            form.validateFields(["confirmarPassword"], { force: true });
        }
        callback();
    };

    const handleConfirmBlur = e => {
        const { value } = e.target;

        setConfirmDirty(confirmDirty || !!value);
    };

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                handleChangePassword(values);
            }
        });
    };

    const handleChangePassword = async values => {
        const { error } = await fetchData({
            method: "post",
            url: "/api/alterar-password/forcar-alterar",
            params: {
                newPassword: values.novaPassword
            }
        });

        if (!error) {
            notify.success("Sucesso", "Senha alterada!");

            if (localStorage.getItem("redirecionar")) {
                setRedirectLink(localStorage.getItem("redirecionar"));
                setRedirect(true);
            } else {
                setRedirectLink(`/utilizador`);
                setRedirect(true);
            }
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const { getFieldDecorator } = form;

    if (notAuthorized) {
        return <Redirect to="/" />;
    }

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Alterar Senha" />
            <Form className="login" onSubmit={handleSubmit}>
                <div className="bloco-alerta">
                    <span className="icon-alerta">
                        <Icon type="info-circle" />
                    </span>
                    <span className="mensagem-alerta">
                        Para poder continuar a utilizar a stepforma em segurança necessita de alterar a sua senha.
                    </span>
                </div>
                <div className="recuperar-password">
                    <Form.Item>
                        {getFieldDecorator("novaPassword", {
                            rules: [
                                {
                                    required: true,
                                    message: "Campo obrigatório"
                                },
                                {
                                    pattern: "^(?=.*[A-Z])(?=.*[0-9])(?=.{6,})",
                                    message: (
                                        <p>A senha deve conter pelo menos uma letra maiúscula, um número e um mínimo de 6 caracteres</p>
                                    )
                                },
                                {
                                    validator: validateToNextPassword
                                }
                            ]
                        })(<Input.Password type="password" placeholder="Nova senha" onBlur={handleConfirmBlur} />)}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator("confirmarPassword", {
                            rules: [
                                {
                                    required: true,
                                    message: "Campo obrigatório"
                                },
                                {
                                    validator: compareToFirstPassword
                                }
                            ]
                        })(<Input.Password type="password" placeholder="Confirmar senha" />)}
                    </Form.Item>
                </div>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button" disabled={loading}>
                        {loading ? <Icon type="loading" /> : null}
                        Alterar e Continuar
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
};
const FormAlterarSenha = Form.create({ name: "form-alterar-senha" })(FromAlterarSenha);

export default FormAlterarSenha;
